"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var bookings_const_1 = require("./bookings.const");
var src_1 = require("@wix/bookings-uou-domain/dist/src");
var WixOOISDKAdapter = /** @class */ (function () {
    function WixOOISDKAdapter(wixCodeApi, platformAPIs, appParams, compId) {
        this.wixCodeApi = wixCodeApi;
        this.platformAPIs = platformAPIs;
        this.appParams = appParams;
        this.compId = compId;
        this.sessionInstanceKey = compId + "_instance";
        this.currentLanguage = this.getCurrentLanguageFromPlatform();
    }
    WixOOISDKAdapter.prototype.isPricingPlanInstalled = function () {
        if (this.wixCodeApi.site) {
            if (this.wixCodeApi.site.isAppSectionInstalled) {
                return Promise.resolve(this.wixCodeApi.site.isAppSectionInstalled({
                    appDefinitionId: bookings_const_1.PRICING_PLAN_APP_DEF_ID,
                    sectionId: bookings_const_1.PRICING_PLAN_SECTION_ID,
                }));
            }
            //TODO: remove when wixCodeApi.site.getAppToken is added to viewerWrapper
            if (this.wixCodeApi.site.getAppToken) {
                return Promise.resolve(!!this.wixCodeApi.site.getAppToken(bookings_const_1.PRICING_PLAN_APP_DEF_ID));
            }
        }
        return this.isPricingPlanInstalledLegacyMode();
    };
    WixOOISDKAdapter.prototype.isPricingPlanInstalledLegacyMode = function () {
        return new Promise(function (resolve) {
            if (window.Wix.Utils.getViewMode() !== 'standalone') {
                window.Wix.isAppSectionInstalled(bookings_const_1.PRICING_PLAN_SECTION_ID, { appDefinitionId: bookings_const_1.PRICING_PLAN_APP_DEF_ID }, function (isInstalled) {
                    resolve(isInstalled);
                });
            }
            else {
                resolve(false);
            }
        });
    };
    WixOOISDKAdapter.prototype.isPreviewMode = function () {
        return this.getViewMode() === 'preview';
    };
    WixOOISDKAdapter.prototype.isEditorMode = function () {
        return this.getViewMode() === 'editor';
    };
    WixOOISDKAdapter.prototype.isDemoMode = function () {
        return this.getDecodedInstance().demoMode;
    };
    WixOOISDKAdapter.prototype.setContainerDimensions = function (newWidth, newHeight) {
        if (this.isRunningInIframe() && this.isEditorMode()) {
            window.Wix.resizeComponent({
                width: newWidth,
                height: newHeight,
            });
        }
    };
    WixOOISDKAdapter.prototype.setContainerHeight = function (newHeight) {
        if (this.isRunningInIframe()) {
            window.Wix.setHeight(newHeight);
        }
    };
    WixOOISDKAdapter.prototype.getExternalId = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.isRunningInIframe()) {
                window.Wix.getExternalId(function (externalId) { return resolve(externalId); });
            }
            else {
                reject('should not be called in OOI mode');
            }
        });
    };
    WixOOISDKAdapter.prototype.getViewMode = function () {
        return this.wixCodeApi.window.viewMode.toLowerCase();
    };
    WixOOISDKAdapter.prototype.getCurrentLanguage = function () {
        return this.currentLanguage;
    };
    WixOOISDKAdapter.prototype.setCurrentLanguage = function (locale) {
        this.currentLanguage = this.getCurrentLanguageFromLocale(locale);
    };
    WixOOISDKAdapter.prototype.getCurrentLanguageFromPlatform = function () {
        return this.getCurrentLanguageFromLocale(this.wixCodeApi.site.language);
    };
    WixOOISDKAdapter.prototype.getCurrentLanguageFromLocale = function (locale) {
        var localeToSubstring = locale ? locale.substring(0, 2) : undefined;
        return localeToSubstring || 'en';
    };
    WixOOISDKAdapter.prototype.isRunningInIframe = function () {
        return !(typeof WorkerGlobalScope !== 'undefined' &&
            self instanceof WorkerGlobalScope);
    };
    WixOOISDKAdapter.prototype.getVisitorId = function () {
        return this.platformAPIs.bi.visitorId;
    };
    WixOOISDKAdapter.prototype.getMetaSiteId = function () {
        return this.platformAPIs.bi.metaSiteId;
    };
    WixOOISDKAdapter.prototype.getOwnerId = function () {
        return this.platformAPIs.bi.ownerId;
    };
    WixOOISDKAdapter.prototype.getBiToken = function () {
        return this.platformAPIs.bi.biToken;
    };
    WixOOISDKAdapter.prototype.getInstanceId = function () {
        return this.appParams.instanceId;
    };
    WixOOISDKAdapter.prototype.getInstance = function () {
        return this.appParams.instance;
    };
    WixOOISDKAdapter.prototype.getAppDefId = function () {
        return this.appParams.appDefinitionId;
    };
    WixOOISDKAdapter.prototype.getStaticsBaseUrl = function () {
        return this.appParams.baseUrls && this.appParams.baseUrls.staticsBaseUrl;
    };
    WixOOISDKAdapter.prototype.getPlatformAPIs = function () {
        return this.platformAPIs;
    };
    WixOOISDKAdapter.prototype.getServiceListStaticsBaseUrl = function () {
        return (this.appParams.baseUrls &&
            this.appParams.baseUrls.serviceListStaticsBaseUrl);
    };
    WixOOISDKAdapter.prototype.getServerBaseUrl = function () {
        return this.isSSR() && this.appParams.baseUrls
            ? this.appParams.baseUrls.serverBaseUrl
            : '/';
    };
    WixOOISDKAdapter.prototype.isOwner = function () {
        return this.getOwnerId() === this.getVisitorId();
    };
    WixOOISDKAdapter.prototype.trackEvent = function (evid, payload) {
        this.wixCodeApi.window.trackEvent(evid, payload);
    };
    WixOOISDKAdapter.prototype.getSiteRevision = function () {
        return this.wixCodeApi.site.revision;
    };
    WixOOISDKAdapter.prototype.getInstanceValue = function (key) {
        var decodedInstance = this.getDecodedInstance();
        if (decodedInstance) {
            return decodedInstance[key] || null;
        }
        return null;
    };
    WixOOISDKAdapter.prototype.getDeviceType = function () {
        return this.wixCodeApi.window.formFactor;
    };
    WixOOISDKAdapter.prototype.getBookingsRelativeUrl = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var isBookingCheckoutInstalled, fullBookingsUrl, baseUrl, urlParts;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.isBookCheckoutInstalled()];
                    case 1:
                        isBookingCheckoutInstalled = _a.sent();
                        return [4 /*yield*/, this.wixCodeApi.site.getSectionUrl({
                                sectionId: isBookingCheckoutInstalled
                                    ? src_1.BOOKINGS_CHECKOUT_SECTION_ID
                                    : src_1.BOOKINGS_SCHEDULER_SECTION_ID,
                            })];
                    case 2:
                        fullBookingsUrl = (_a.sent()).url;
                        baseUrl = this.wixCodeApi.location.baseUrl;
                        urlParts = fullBookingsUrl.split(baseUrl);
                        return [2 /*return*/, urlParts.length > 1 ? urlParts[1] : fullBookingsUrl];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.navigateToBookingsWithSuffix = function (suffix) {
        if (suffix === void 0) { suffix = ''; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var bookingsRelativeUrl;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBookingsRelativeUrl()];
                    case 1:
                        bookingsRelativeUrl = _a.sent();
                        this.wixCodeApi.location.to(bookingsRelativeUrl + suffix);
                        return [2 /*return*/];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.isSSR = function () {
        return this.wixCodeApi.window.rendering.env === 'backend';
    };
    WixOOISDKAdapter.prototype.getCompId = function () {
        return this.compId;
    };
    WixOOISDKAdapter.prototype.isSessionInstanceSet = function () {
        return (this.platformAPIs.storage.session.getItem(this.sessionInstanceKey) ===
            this.getInstance());
    };
    WixOOISDKAdapter.prototype.setSessionInstance = function () {
        this.platformAPIs.storage.session.setItem(this.sessionInstanceKey, this.getInstance());
    };
    WixOOISDKAdapter.prototype.isViewDirectionRtl = function () {
        return bookings_const_1.RTL_LANGUAGES.indexOf(this.getCurrentLanguage()) > -1;
    };
    WixOOISDKAdapter.prototype.getScale = function () {
        var _this = this;
        return new Promise(function (resolve) {
            if (_this.isRunningInIframe()) {
                window.Wix.getBoundingRectAndOffsets(function (_a) {
                    var scale = _a.scale;
                    return resolve(scale);
                });
            }
            else {
                resolve(1);
            }
        });
    };
    WixOOISDKAdapter.prototype.getDecodedInstance = function () {
        var instance = this.getInstance();
        if (!instance) {
            return null;
        }
        var encodedInstance = instance.substring(instance.indexOf('.') + 1);
        return JSON.parse(this.decodeBase64(encodedInstance));
    };
    WixOOISDKAdapter.prototype.decodeBase64 = function (str) {
        if (typeof atob !== 'undefined') {
            return atob(str);
        }
        return '{}';
    };
    WixOOISDKAdapter.prototype.isBookCheckoutInstalled = function () {
        if (this.isRunningInIframe()) {
            return new Promise(function (resolve) {
                window.Wix.isAppSectionInstalled(src_1.BOOKINGS_CHECKOUT_SECTION_ID, { appDefinitionId: src_1.BOOKINGS_APP_DEF_ID }, function (isInstalled) {
                    resolve(isInstalled);
                });
            });
        }
        return Promise.resolve(this.wixCodeApi.site.isAppSectionInstalled({
            sectionId: src_1.BOOKINGS_CHECKOUT_SECTION_ID,
            appDefinitionId: src_1.BOOKINGS_APP_DEF_ID,
        }));
    };
    WixOOISDKAdapter.prototype.getCsrfToken = function () {
        return this.platformAPIs.getCsrfToken();
    };
    WixOOISDKAdapter.prototype.getBookingsUrlSuffix = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var fullBookingsUrl, fullUrl, urlParts, bookingsSuffix;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.wixCodeApi.site.getSectionUrl({
                            sectionId: src_1.BOOKINGS_LIST_SECTION_ID,
                        })];
                    case 1:
                        fullBookingsUrl = (_a.sent()).url;
                        fullUrl = this.wixCodeApi.location.url;
                        urlParts = fullUrl.split(fullBookingsUrl);
                        bookingsSuffix = urlParts.length > 1 && urlParts[1] ? urlParts[1] : '';
                        return [2 /*return*/, this.isSuffixContainOnlyQueryParam(bookingsSuffix)
                                ? ''
                                : bookingsSuffix];
                }
            });
        });
    };
    WixOOISDKAdapter.prototype.isSuffixContainOnlyQueryParam = function (urlSuffix) {
        var splittedByQueryParam = urlSuffix.split('?');
        return (splittedByQueryParam.length > 1 &&
            (!splittedByQueryParam[0] && splittedByQueryParam[1]));
    };
    return WixOOISDKAdapter;
}());
exports.WixOOISDKAdapter = WixOOISDKAdapter;
//# sourceMappingURL=WixOOISDKAdapter.js.map